var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "completa-preventivo" },
    [
      _c(
        "div",
        {
          staticClass:
            "cursor-pointer bg-primary text-center py-4 d-flex justify-content-center",
          attrs: { id: "completaPreventivo" },
          on: { click: _vm.onCompleta }
        },
        [_vm._m(0)]
      ),
      _vm._v(" "),
      _c("ModalSpesePratica", {
        ref: "modalSpesePratica",
        on: { confirm: _vm.onConfermaSpese }
      }),
      _vm._v(" "),
      _c("ModalCompletaPratica", { ref: "modalCompletaPratica" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-center" }, [
      _c(
        "h6",
        {
          staticClass:
            "adj-icon before-icon-completa-preventivo text-uppercase text-white m-0 mr-2"
        },
        [_vm._v("\n        completa il preventivo\n      ")]
      ),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../assets/images/svg/white/icone_arrow-3.svg"),
          width: "14px"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5df248ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5df248ee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/CompletaPreventivo.vue
// module id = null
// module chunks = 